import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'orderBy',
})
export class OrderByPipe implements PipeTransform {
  transform(value: any[]): unknown {
    value.sort((a, b) => {
      let aDate = moment(a.data_compra, 'YYYY-MM-DD');
      let bDate = moment(b.data_compra, 'YYYY-MM-DD');
      return aDate.isBefore(bDate) ? 1 : -1;
    });
    return value;
  }
}
